export enum UserTelemetryKeys {
  NoOfGroupsAssigned = 'IAM_noOfGroupsAssigned',
  NoOfUsersAdded = 'IAM_noOfUsersAdded',
  NoOfRolesAssigned = 'IAM_noOfRolesAssigned',
  TargetObjectId = 'IAM_targetObjectId',
  ErrorEvent = 'IAM_isErrorEvent',
  ErrorReason = 'IAM_errorReason',
  ErrorCode = 'IAM_errorCode',
}

export type TelemetryKeys = UserTelemetryKeys;
export type UserTelemetryValues = string | number | boolean;

export const TRUE_VALUE = true;
export const FALSE_VALUE = false;
export const UNKNOWN_ERROR = 'Unknown Error';
export const NETWORK_ERROR = 'Network Error';
